export default import.meta.ROLLDOWN_FILE_URL_kzvJp2SHYBS_Ak6CuhUW5A